<template>
    <td-dialog :title="title" :before-close="userDialogClose" :visible.sync="dialogUserVisible" width="65%" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formUserInfo" ref="formUserInfo" :rules="rules">
            <input type="password" style="outline:none;border:0;width:0;height:0;float:left;background-color: rgba(0, 0, 0, 0);" />
            <el-row style="margin-top:2px">
                <el-col :span="12">
                    <el-form-item :label="$t('common.USERNAME')" :label-width="formLabelWidth" prop="sName">
                        <td-input v-model="formUserInfo.sName" :disabled="isAddData ? false : true" :maxlength="20"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="!isAddData">
                    <td-permission :roles="roles">
                        <div slot="havePermission">
                            <el-form-item :label="$t('common.RESETUSERINFO')" label-width="180%">
                                <td-button :roles="roles" @click="resetDialog()">{{ $t('common.RESET') }}</td-button>
                            </el-form-item>
                        </div>
                    </td-permission>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <div v-if="isAddData">
                        <el-form-item :label="$t('common.PASSWORD')" :label-width="formLabelWidth" prop="sNewPassword">
                            <td-input type="password" v-model="formUserInfo.sNewPassword" :maxlength="50"></td-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div v-if="isAddData">
                        <el-form-item :label="$t('common.CONFIRMATION')" :label-width="formLabelWidth" prop="sConfirmPassword">
                            <td-input type="password" v-model="formUserInfo.sConfirmPassword" :maxlength="50"></td-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('common.DEPTMENT')" :label-width="formLabelWidth">
                        <td-input type="text" v-model="checkedOrgList" :readonly="true" :placeholder="$t('common.PLEASE_SELECT')"></td-input>
                        <td-button style="min-width:50px;margin: 0 0 0 10px;" @click="showTree()">{{ $t('common.CHOOSE') }}</td-button>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('role.DOOR_ROLE')" :label-width="formLabelWidth">
                        <td-select v-model="formUserInfo.doorRole" :placeholder="$t('common.PLEASE_SELECT')" :options="this.doorRoleList" keys="sId" text="sName"> </td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('common.VALIDITY_TO')" :label-width="formLabelWidth">
                        <td-date-time type="date" :placeholder="$t('common.SELECT_DATE')" v-model="formUserInfo.dateTo" :pickerOptions="pickerOptions0" :editable="false"></td-date-time>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form @submit.native.prevent  :model="formIpInfo" ref="formIpInfo" :rules="rulesIp">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.IP_WHITE_LIST') }}</span>
                            <el-popover placement="top" width="200" v-model="showIp">
                                <el-form-item prop="newIpInfo">
                                    <td-input v-model="formIpInfo.newIpInfo" :maxlength="50"></td-input>
                                </el-form-item>
                                <div style="text-align: right; margin: 0">
                                    <td-button size="mini" type="button" @click="showIp = false">{{ $t('common.CANCAL') }}</td-button>
                                    <td-button type="primary" size="mini" @click="addIp()">{{ $t('common.CONFIRM') }}</td-button>
                                </div>
                            </el-popover>
                            <td-button @click="(showIp = true), (formIpInfo.newIpInfo = '')" style="float: right; padding: 3px 0;" type="text">{{ $t('common.ADD') }}</td-button>
                        </div>
                        <div v-for="ip in ipList" :key="ip" class="text item">
                            <el-col :span="8">
                                <el-form-item :label="ip">
                                    <td-button v-if="ip !== ''" @click="deleteIp(ip)" type="text">{{ $t('common.DELETE') }}</td-button>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-card>
                </el-form>
            </el-row>
            <el-row v-if="false">
                <el-form @submit.native.prevent :model="formMacInfo" ref="formMacInfo" :rules="rulesMac">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.MAC_WHITE_LIST') }}</span>
                            <el-popover placement="top" width="200" v-model="showMac">
                                <el-form-item prop="newMacInfo">
                                    <td-input v-model="formMacInfo.newMacInfo"></td-input>
                                </el-form-item>
                                <div style="text-align: right; margin: 0">
                                    <td-button size="mini" type="button" @click="showMac = false">{{ $t('common.CANCAL') }}</td-button>
                                    <td-button type="primary" size="mini" @click="addMac()">{{ $t('common.CONFIRM') }}</td-button>
                                </div>
                            </el-popover>
                            <td-button @click="(showMac = true), (formMacInfo.newMacInfo = '')" style="float: right; padding: 3px 0;" type="text">{{ $t('common.ADD') }}</td-button>
                        </div>
                        <div v-for="mac in macList" :key="mac" class="text item">
                            <el-col :span="8">
                                <el-form-item :label="mac">
                                    <td-button v-if="mac !== ''" @click="deleteMac(mac)" type="text">{{ $t('common.DELETE') }}</td-button>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-card>
                </el-form>
            </el-row>
            <el-row>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.ROLE_INFO') }}</span>
                    </div>
                    <el-col :span="24">
                        <!-- <el-checkbox-group v-model="checkList">
                        <el-checkbox v-for="role in sysRoles" :label="role.sId" :key="role.sId" style="width:100px;margin:10px;">{{role.sName}}</el-checkbox>
                    </el-checkbox-group> -->
                        <td-checkbox-group
                            :hasBtn="false"
                            ref="roleCheckGroup"
                            :labelWidth="85"
                            :overLenghOmission="true"
                            v-model="checkList"
                            :allList="sysRoles"
                            keys="sId"
                            text="sName"
                            checkBoxClass="checkboxstyle"
                        ></td-checkbox-group>
                    </el-col>
                </el-card>
            </el-row>
            <el-row v-for="(extend, j) in formUserInfo.userExtends" :key="extend.sModuleId">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ extend.sModuleName }}</span>
                    </div>
                    <div v-for="(item, k) in extend.extendList" :key="item.sId">
                        <el-col :span="item.sExtendType === 'checkboxgroup' ? 24 : 8">
                            <el-form-item
                                :key="item.sId"
                                :label-width="item.sExtendType === 'checkboxgroup' ? '15%' : formLabelWidth"
                                :label="item.sName"
                                :prop="'userExtends.' + j + '.extendList.' + k + '.optionValue'"
                                :rules="getCheckRule(item)"
                            >
                                <div v-if="item.sExtendType === 'input'">
                                    <td-input v-model="item.optionValue" :type="item.sParam"></td-input>
                                </div>
                                <div v-if="item.sExtendType === 'combobox'" style="height:36px;">
                                    <td-select v-model="item.optionValue" :options="item.sParam.split(',')" :hasBasicTypes="true"></td-select>
                                    <!-- <el-select v-model="item.optionValue" :placeholder="$t('common.PLEASE_SELECT')">
                                        <el-option v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"> </el-option>
                                    </el-select> -->
                                </div>
                                <div v-if="item.sExtendType === 'date'">
                                    <el-date-picker type="date" :placeholder="$t('common.SELECT_DATE')" v-model="item.optionValue"></el-date-picker>
                                </div>
                                <div v-if="item.sExtendType === 'radio'">
                                    <el-radio-group v-model="item.optionValue">
                                        <el-radio v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"></el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-if="item.sExtendType === 'checkbox'">
                                    <el-checkbox v-model="item.optionValue" :label="item.sParam">{{ item.sParam }}</el-checkbox>
                                </div>
                                <div v-if="item.sExtendType === 'checkboxgroup'">
                                    <!-- <el-checkbox-group v-model="item.optionValue">
                                        <el-checkbox v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" style="width:100px;margin:5px 0 0 0;"></el-checkbox>
                                    </el-checkbox-group> -->
                                    <td-checkbox-group :allList="item.sParam.split(',')" v-model="item.optionValue" :hasBasicTypes="true"></td-checkbox-group>
                                </div>
                            </el-form-item>
                        </el-col>
                    </div>
                </el-card>
                <!-- <el-button style="float: right; padding: 3px 0" @click="getSelection()" type="text">添加</el-button> -->
            </el-row>
            <dialog-tree
                v-if="dialogOrgTreeVisible"
                :title="titleOrg"
                :dialogOrgTreeVisible="dialogOrgTreeVisible"
                :orgTreeUrl="this.orgTreeUrl"
                :checkedOrgIdList="this.checkedOrgIdList"
                ref="addOrModifyInfo"
                @orgTreeDialogClose="orgTreeDialogClose"
                @getCheckedOrgList="getCheckedOrgList"
            ></dialog-tree>
            <dialog-reset-password
                v-if="dialogResetPasswordVisible"
                :dialogResetPasswordVisible="dialogResetPasswordVisible"
                :sysFlg="sysFlg"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @userDialogClose="userDialogClose"
                @submit="submit"
                @resetPasswordDialogClose="resetPasswordDialogClose"
            ></dialog-reset-password>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formUserInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click="userDialogClose()">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import dialogOrgTree from './dialogOrgTree.vue';
import dialogResetPassword from './dialogResetPassword.vue';
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogUserVisible', 'editItem', 'isAddData', 'sysFlg', 'sysList'],
    components: {
        'dialog-tree': dialogOrgTree,
        'dialog-reset-password': dialogResetPassword
    },
    created() {
        this.getMenuUrl();
        this.initRegex();
        let data = [];
        let param = {
            sysID: this.sysFlg,
            orgFlg: 0
        };
        resourceApi.getRoleInfo(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getRoleInfo', response.data.statusMessage);
                return;
            }
            data = response.data.content;
            this.sysRoles = data;
        });
        let doorListparam = {
            sysID: this.sysFlg,
            orgFlg: 2
        };
        let doorListData = [];
        resourceApi.getRoleInfo(JSON.stringify(doorListparam), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getRoleInfo', response.data.statusMessage);
                return;
            }
            doorListData = response.data.content;
            this.doorRoleList = doorListData;
        });
        resourceApi.getUserExtends({ sysFlg: this.sysFlg }, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserExtends', response.data.statusMessage);
                return;
            }
            data = response.data.content;
            this.formUserInfo.userExtends = data;

            for (let i = 0; i < this.formUserInfo.userExtends.length; i++) {
                for (let index = 0; index < this.formUserInfo.userExtends[i].extendList.length; index++) {
                    const element = this.formUserInfo.userExtends[i].extendList[index];
                    this.rules[element.sId] = [];
                    if (element.isCheckNull === 1) {
                        this.rules[element.sId].push({
                            required: true,
                            validator: this.validateExtendName,
                            trigger: 'blur'
                        });
                    } else {
                        this.rules[element.sId].push({
                            validator: this.validateExtendName,
                            trigger: 'blur'
                        });
                    }
                }
            }
            // 为编辑状态则进行初始化数据
            if (!this.isAddData) {
                this.initEditData();
                let content = {
                    sId: this.editItem.userId,
                    sysFlg: this.sysFlg
                };

                resourceApi.getUserExtendsValues(JSON.stringify(content), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('user/getUserExtendsValues', response.data.statusMessage);
                        return;
                    }

                    let values = response.data.content;
                    if (values.length === 0) {
                        return;
                    }
                    let i = 0;
                    this.formUserInfo.userExtends.forEach(v => {
                        v.extendList.forEach(val => {
                            if (val.sExtendType === 'checkboxgroup') {
                                let arr = values[i].sValue.split('|');
                                val.optionValue = arr;
                            } else if (val.sExtendType === 'checkbox') {
                                let arr = values[i].sValue === 'true';

                                val.optionValue = arr;
                            } else {
                                val.optionValue = values[i].sValue;
                            }
                            i++;
                        });
                    });
                });
            } else {
                // User类型默认选中第一个
                // this.formUserInfo.iType = String(this.options[0].value)
                this.formUserInfo.userExtends.forEach(v => {
                    v.extendList.forEach(val => {
                        if (val.sExtendType === 'checkboxgroup') {
                            val.optionValue = [];
                        }
                    });
                });
            }
        });
    },
    // 定义变量
    data() {
        let validateIp = (rule, value, callback) => {
            if (this.ipList.indexOf(this.formIpInfo.newIpInfo) > -1) {
                callback(this.$t('error.ERROR_IP_REPEAT'));
            } else {
                callback();
            }
        };
        let validateMac = (rule, value, callback) => {
            if (this.macList.indexOf(this.formMacInfo.newMacInfo) > -1) {
                callback(this.$t('error.ERROR_MAC_REPEAT'));
            } else {
                callback();
            }
        };
        let validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else {
                if (this.formUserInfo.sConfirmPassword !== '') {
                    this.$refs.formUserInfo.validateField('sConfirmPassword');
                }
                callback();
            }
        };
        let validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else if (this.formUserInfo.sNewPassword !== value) {
                callback(this.$t('error.ERROR_PASSWORD_NOT_EQUAl'));
            } else {
                callback();
            }
        };
        let validateUserName = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formUserInfo.sId;
            }
            let param = {
                sName: value,
                sysFlg: this.sysFlg,
                sId: sId
            };
            // console.log(param)
            resourceApi.getUserInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_USER_CAPTION_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        return {
            pg: window.pgCommon,
            // User表单信息
            formUserInfo: {
                sId: '',
                sName: '',
                doorRole: '',
                dateTo: '2099-01-01',
                sConfirmPassword: '',
                sNewPassword: '',
                userExtends: []
            },
            formIpInfo: {
                newIpInfo: ''
            },
            formMacInfo: {
                newMacInfo: ''
            },
            groups: {
                label: 'name',
                children: 'zones'
            },
            defaultDeptProps: {
                children: 'children',
                id: 'id',
                label: 'label'
            },
            titleOrg: this.$t('common.TITLEORG'),
            orgTreeUrl: { query: '', search: '' },
            orgList: [],
            roles: ['admin'],
            doorRoleList: [],
            showIp: false,
            dialogResetPasswordVisible: false,
            dialogOrgTreeVisible: false,
            showMac: false,
            ipList: [],
            macList: [],
            userExtends: [],
            count: 1,
            checkList: [],
            checkedOrgList: '',
            checkedOrgIdList: [],
            sysRoles: [],
            checkedUser: [1, 4],
            loading: false,
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            formLabelWidth: '30%',
            passwordRule: '',
            ruleMessage: '',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    },
                    { validator: validateUserName, trigger: 'blur' }
                ],
                sNewPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                sConfirmPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ]
            },
            rulesIp: {
                newIpInfo: [
                    { required: true, message: this.$t('error.ERROR_IP_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.IP_RULE,
                        message: this.$t('error.ERROR_IP_FORMAT')
                    },
                    { validator: validateIp, trigger: 'blur' }
                ]
            },
            rulesMac: {
                newMacInfo: [
                    { required: true, message: this.$t('error.ERROR_MAC_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.IP_RULE,
                        message: this.$t('error.ERROR_MAC_FORMAT')
                    },
                    { validator: validateMac, trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        initRegex() {
            let params = {
                sTag: 'PASSWORD_RULE'
            };
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                this.passwordRule = response.data.content[0].sCode;
                this.ruleMessage = response.data.content[0].sValue;
                let regx = {
                    pattern: this.passwordRule,
                    message: this.ruleMessage
                };
                this.rules.sNewPassword.push(regx);
            });
        },
        getCheckRule(item) {
            var rules = [];
            if (item.iRequired == 1) {
                let requireRules = { required: true, message: this.$t('error.ERROR_INPUT'), trigger: 'change' };
                rules.push(requireRules);
            }
            if (!this.$util.isEmpty(item.sCheckRule)) {
                let otherRules = { pattern: item.sCheckRule, message: item.sCheckTips };
                rules.push(otherRules);
            }
            return rules;
        },
        getMenuUrl() {
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.sysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                    this.orgTreeUrl.query = this.hostUrl + this.deptUrl;
                    this.orgTreeUrl.search = this.hostUrl + '/OrgManagerController/find';
                }
            }
        },
        validateExtendName: function(rule, value, callback) {
            for (let j = 0; j < this.formUserInfo.userExtends.length; j++) {
                for (let i = 0; i < this.formUserInfo.userExtends[j].extendList.length; i++) {
                    const element = this.formUserInfo.userExtends[j].extendList[i];
                    if (element.sId === rule.field) {
                        if (element.optionValue === '' || element.optionValue == null || element.optionValue === undefined) {
                            if (element.isCheckNull === 1) {
                                const message = this.$t('common.PLEASE_INPUT') + element.sName;
                                callback(message);
                                break;
                            }
                        } else {
                            this.checkIllegal(element, callback);
                        }
                        callback();
                        break;
                    }
                }
            }
            callback();
        },
        // 动态控件非法正则验证
        checkIllegal(item, callback) {
            if (item.sExtendType === 'input') {
                let reg = new RegExp(this.$regex.INPUT_RULE);
                if (!reg.test(item.optionValue)) {
                    callback(this.$t('error.ERROR_INPUT_ILLEGAL'));
                    return;
                }
            }

            callback();
        },
        // 初始化编辑数据
        initEditData() {
            this.formUserInfo.sName = this.editItem.userName;
            this.formUserInfo.dateTo = this.formatDate(new Date(this.editItem.dtLimit * 1), 'yyyy-MM-dd');
            // this.formUserInfo.dateTo = this.editItem.dtLimit
            this.formUserInfo.sId = this.editItem.userId;

            resourceApi.getUserIpList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserIpList', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;

                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    this.ipList.push(element.sIp);
                }
            });
            resourceApi.getUserMacList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserMacList', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    this.macList.push(element.sMac);
                }
            });
            this.checkList = this.editItem.roleId.split(',');
            // console.log(this.checkList)
            let param = {
                sId: this.formUserInfo.sId,
                sysFlg: this.sysFlg,
                orgFlg: 1
            };
            resourceApi.getUserRoleInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserRoleInfo', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                let orgIds = [];
                let orgNames = [];
                let result = [];
                for (let index = 0; index < array.length; index++) {
                    orgIds.push(array[index].sId);
                    orgNames.push(array[index].sName);
                    result.push({ id: array[index].sId, caption: array[index].sName });
                }
                this.checkedOrgIdList = result;
                this.checkedOrgList = orgNames.join(',');
            });
            let doorRoleQueryParam = {
                sId: this.formUserInfo.sId,
                sysFlg: this.sysFlg,
                orgFlg: 2
            };
            resourceApi.getUserRole(JSON.stringify(doorRoleQueryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserRole', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                if (array.length > 0) {
                    this.formUserInfo.doorRole = array[0].sId;
                }
            });
        },
        addIp() {
            if (this.formIpInfo.newIpInfo === '') {
                this.$message({ showClose: true, message: this.$t('error.ERROR_IP_NULL'), type: 'error' });
                return;
            }
            if (this.ipList.indexOf(this.formIpInfo.newIpInfo) > -1) {
                this.$message({ showClose: true, message: this.$t('error.ERROR_IP_REPEAT'), type: 'error' });
                return;
            }
            let reg = new RegExp(this.$regex.IP_RULE);
            if (reg.test(this.formIpInfo.newIpInfo)) {
                this.ipList.push(this.formIpInfo.newIpInfo);
                this.showIp = false;
            } else {
                this.$message({ showClose: true, message: this.$t('error.ERROR_IP_FORMAT'), type: 'error' });
                return;
            }
        },
        deleteIp(ip) {
            let index = this.ipList.indexOf(ip);
            if (index > -1) {
                this.ipList.splice(index, 1);
            }
        },
        addMac() {
            if (this.formMacInfo.newMacInfo === '') {
                this.$message({ showClose: true, message: this.$t('error.ERROR_MAC_NULL'), type: 'error' });
                return;
            }
            if (this.macList.indexOf(this.formMacInfo.newMacInfo) > -1) {
                this.$message({ showClose: true, message: this.$t('error.ERROR_MAC_REPEAT'), type: 'error' });
                return;
            }
            let reg = new RegExp(this.$regex.MAC_RULE);
            if (reg.test(this.formMacInfo.newMacInfo)) {
                this.macList.push(this.formMacInfo.newMacInfo);
                this.showMac = false;
            } else {
                this.$message({ showClose: true, message: this.$t('error.ERROR_MAC_FORMAT'), type: 'error' });
            }
        },
        deleteMac(mac) {
            let index = this.macList.indexOf(mac);
            if (index > -1) {
                this.macList.splice(index, 1);
            }
        },
        // 提交数据
        submitForm(formName) {
            this.formIpInfo.newIpInfo = '';
            this.formMacInfo.newMacInfo = '';
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.formUserInfo.sNewPassword !== this.formUserInfo.sConfirmPassword) {
                        this.$message({ showClose: true, message: this.$t('error.ERROR_PASSWORD_NOT_EQUAl'), type: 'error' });
                        this.loading = false;
                        return;
                    }
                    let moduleIds = [];
                    let moduleNames = [];
                    let extendVals = [];
                    let extendIds = [];

                    this.formUserInfo.userExtends.forEach(v => {
                        moduleIds.push(v.sModuleId);
                        moduleNames.push(v.sModuleName);
                        v.extendList.forEach(val => {
                            extendIds.push(val.sId);
                            if (Array.isArray(val.optionValue)) {
                                extendVals.push(val.optionValue.join('|'));
                            } else {
                                extendVals.push(val.optionValue);
                            }
                        });
                    });
                    // console.log(this.formUserInfo.userExtends)
                    //
                    let checkGroup = '';

                    if (Array.isArray(this.checkList)) {
                        checkGroup = this.$refs.roleCheckGroup.getCheckList().join(',');
                        // checkGroup = this.checkList.join(',')
                    }
                    if (this.formUserInfo.doorRole !== '') {
                        if (checkGroup !== '') {
                            checkGroup += ',' + this.formUserInfo.doorRole;
                        } else {
                            checkGroup = this.formUserInfo.doorRole;
                        }
                    }
                    let ipListStr = '';
                    if (this.ipList.length > 0) {
                        ipListStr = this.ipList.join('#');
                    }
                    let macListStr = '';
                    if (this.macList.length > 0) {
                        macListStr = this.macList.join('#');
                    }
                    let checkOrg = '';
                    for (let index = 0; index < this.checkedOrgIdList.length; index++) {
                        const element = this.checkedOrgIdList[index];
                        if (index === 0) {
                            checkOrg = element.id;
                        } else {
                            checkOrg += ',' + element.id;
                        }
                    }
                    let content = {
                        sId: this.formUserInfo.sId,
                        sName: this.formUserInfo.sName,
                        oldPassword: this.formUserInfo.sPassword,
                        newPassword: this.formUserInfo.sNewPassword,
                        sConfirmPassword: this.formUserInfo.sConfirmPassword,
                        dateTo: this.formUserInfo.dateTo,
                        ipList: ipListStr,
                        macList: macListStr,
                        sysFlg: this.sysFlg,
                        roleList: checkGroup,
                        extendIds: extendIds.join(','),
                        extendValues: extendVals.join(','),
                        orgIds: checkOrg
                    };
                    // 新增编辑
                    if (this.isAddData) {
                        resourceApi.insertUserInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('user/insertUserInfo', response.data.statusMessage);
                                this.loading = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.userDialogClose();
                            this.$emit('submit');
                        });
                    } else {
                        resourceApi.updateUserInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('user/updateUserInfo', response.data.statusMessage);
                                this.loading = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.userDialogClose();
                            this.$emit('submit');
                        });
                    }
                }
            });
        },
        submit() {
            this.$emit('submit');
        },
        // 关闭窗口之前需要调用的方法
        userDialogClose() {
            this.$emit('userDialogClose');
            this.$refs['formUserInfo'].resetFields(); // 重置表单数据
        },
        getSelection() {
            let temp = [];
            let idTemp = [];
            let extendVals = [];
            let extendIds = [];
            this.formUserInfo.userExtends.forEach(v => {
                // v.value = ''
                idTemp.push(v.sModuleId);
                temp.push(v.sModuleName);
                // idTemp.push(v.sId)
                // temp.push(v.optionValue)
                v.extendList.forEach(val => {
                    extendIds.push(val.sId);

                    if (Array.isArray(val.optionValue)) {
                        extendVals.push(val.optionValue.join('|'));
                    } else {
                        extendVals.push(val.optionValue);
                    }
                });
            });
            //
            return temp;
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        resetDialog() {
            this.dialogResetPasswordVisible = true;
        },
        checkChange(item, node, self) {
            // if (node === true) { // 点击未选中复选框
            //     this.editCheckId = item.sId
            //     this.$refs.tree.setCheckedKeys([item.sId])
            // } else {
            //     if (this.editCheckId === item.sId) { // 点击已选中复选框，保证至少一个中
            //         this.$refs.tree.setCheckedKeys([item.sId])
            //     }
            // }
        },
        // nodeClick (item, node, self) {
        //     this.editCheckId = item.sId
        //     this.dialogOrgTreeVisible = false
        //     this.formPermissionInfo.sParentId = item.sId
        //     this.formPermissionInfo.resName = item.sName
        //     this.$refs.tree.setCheckedKeys([item.sId])
        // },
        showTree() {
            this.dialogOrgTreeVisible = true;
        },
        orgTreeDialogClose() {
            this.dialogOrgTreeVisible = false;
        },
        resetPasswordDialogClose() {
            this.dialogResetPasswordVisible = false;
        },
        getCheckedOrgList(data) {
            let orgNameList = [];
            let orgIdList = [];
            let result = [];
            for (let index = 0; index < data.length; index++) {
                orgNameList.push(data[index].caption);
                orgIdList.push(data[index].id);
                result.push({ id: data[index].id, caption: data[index].caption, parentId: data[index].parentId });
            }
            this.checkedOrgList = orgNameList.join(',');
            this.checkedOrgIdList = result;
        },
        formatDate(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
                }
            }
            return fmt;
        }
    }
};
</script>
<style scoped>
.checkboxstyle {
    width: 165px;
    margin: 5px !important;
}
.el-card {
    padding-bottom: 26px;
}
</style>
